import type { FireIconProps } from './types';

export default function Ambulance({ size = 24, color = 'currentColor', strokeWidth = 2, className, ...props }: FireIconProps) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24"
      fill="none" stroke={color} strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round"
      className={className} {...props}>
      {/* Body */}
      <rect x="1" y="7" width="16" height="8" rx="1" />
      {/* Cab */}
      <path d="M17 10h3l2 3v2h-5" />
      {/* Cross */}
      <line x1="7" y1="9" x2="7" y2="13" />
      <line x1="5" y1="11" x2="9" y2="11" />
      {/* Undercarriage */}
      <line x1="1" y1="15" x2="22" y2="15" />
      {/* Wheels */}
      <circle cx="5" cy="17.5" r="2" />
      <circle cx="19" cy="17.5" r="2" />
      {/* Light */}
      <rect x="3" y="5" width="3" height="2" rx="0.5" />
    </svg>
  );
}
